/**
 * 场景化上下文管理 - 独立页面
 *
 * 薄壳组件：复用 ScenarioContextTable，仅添加页面标题和容器。
 * 所有核心功能（表格列定义、筛选、增删改查、权限控制）由 ScenarioContextTable 统一实现，
 * 避免两处维护导致的不一致（如嵌入版模态框缺少类型列、内容列等问题）。
 */
import React from "react";
import ScenarioContextTable from "./components/ScenarioContextTable";

const ScenarioContextList = () => {
    return (
        <div className="page-container">
            {/* 表格组件（非嵌入模式）- 页面标题和操作按钮由 ScenarioContextTable 自行渲染 */}
            <ScenarioContextTable embedded={false} />
        </div>
    );
};

export default ScenarioContextList;
